import * as React from 'react';

export const header = {
  heading: 'Links'
};
export const richText1 = {
  id: 'Links',
  html:
    '                <p>Our websites contain links to third party websites. If you click on one of those links, \n'
    + '                 you will be taken to websites we do not control. This Privacy and Security Statement does not \n'
    + '                 apply to the information practices of those websites. You should read the privacy policies \n'
    + '                 of other websites carefully. We are not responsible for third party websites. </p> \n'

};
